import { useEffect, useRef, useState } from 'react'
import '../addStock.css'

const StringTypeInput = (props: any) => {
  const { row, column, table, getValue } = props.props;
  const [editValue, setValue] = useState(getValue() !== '' ? getValue() : null)



  // console.log("re-render..........")
  // console.log("Get..........",props.props.getValue());

  useEffect(() => {
    const cellValue = getValue();
 if(cellValue!==undefined && cellValue !== null){
  setValue(cellValue);
 }
  }, [getValue()])


  const updateValue = (val: string) => {
    setValue(val)
  }

  const onBlur = () => {
    table.options.meta?.updateData(row.index, column.id, editValue);
  }

  const refInput = useRef<HTMLInputElement>(null)
  return (
    // <div className='input-group'>
    <input

      className='table-input'
      value={editValue}
      placeholder={props.placeholder}
      ref={refInput}
      onChange={(event) => updateValue(event.target.value)}
      onBlur={() => onBlur()}
    />
  )
}

export default StringTypeInput
